module.exports = __webpack_public_path__ + "img/background5.08487d46.jpg";